import "./App.css";

import {
  Footer,
  Features,
  Blog,
  Possibility,
  WhatGPT3,
  Header,
} from "./container";
import { Cta, Brand, Navbar } from "./Components";

function App() {
  return (
    <div className="App">
      <div className="gradient__bg">
        <Navbar />
        <Header />
      </div>
      <Brand />
      <WhatGPT3 />
      <Features />
      <Possibility />
      <Cta />
      <Blog />
      <Footer />
    </div>
  );
}

export default App;
